import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';
import ReactHtmlParser from 'react-html-parser';
import moment from 'moment';
import 'moment/min/locales';
import 'moment/locale/fr';
import Link from "react-router-dom/Link";
import Button from "@material-ui/core/Button/Button";
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';

class NewsDetails extends Component {
    render() {
        const {news} = this.props;

        moment.locale('fr');

        let idArticle = 'news-' + news.id;

        let title = news.title;
        if (news.title_html !== '' && news.title_html !== null) {
            title = ReactHtmlParser(news.title_html);
        }

        const pageTitle = process.env.REACT_APP_SITE_TITLE + ' | ' + news.title;

        return (
            <Fragment>
                <Helmet
                    bodyAttributes={{
                        class: 'news-details'
                    }}
                >
                    <title>{ReactHtmlParser(pageTitle)}</title>
                </Helmet>
                <article id={idArticle} className="news">
                    <header>
                        <div className="row">
                            <div className="col col-9">
                                <Button size="medium" className="btnBack" component={props => <Link to="/actualites" {...props}/>}>
                                    <KeyboardBackspaceIcon className="btnIcon" />
                                    Retour
                                </Button>

                                <h1>{title}</h1>
                            </div>
                        </div>
                    </header>
                    <div className="row row-content">
                        <div className="col col-12">
                            <div className="content-inner">
                                {ReactHtmlParser(news.content)}
                            </div>
                        </div>
                    </div>
                </article>
            </Fragment>
        );
    }
}

NewsDetails.propTypes = {
    news: PropTypes.object.isRequired,
};

export default NewsDetails;



// WEBPACK FOOTER //
// ./src/features/News/components/Details/NewsDetails.js